export default {
  cards: {
    error: {
      color: '#d00'
    },
    success: {
      color: '#1DAD23'
    }
  }
}